// © Microsoft Corporation. All rights reserved.
import React from 'react';
import { DefaultButton, PrimaryButton, Stack, ActionButton } from '@fluentui/react';
import { VideoCameraEmphasisIcon } from '@fluentui/react-icons-northstar';
import {
    endCallContainerStyle,
    endCallTitleStyle,
    buttonStyle,
    mainStackTokens,
    buttonsStackTokens,
    upperStackTokens,
    videoCameraIconStyle,
    bottomStackFooterStyle
} from './styles/EndCall.styles';
import {

    noShowButtonStyle,

    RatingButtonStyle
} from './styles/CommandPanel.styles';
import { postinterviewcomplete, UpdateCandidateStatus } from 'Utils/interviewcomplete';
import { uriCode, ParticipantModel, ParticipantInfo, uriGid } from 'Utils/participantInfo';
import * as signalR from "@microsoft/signalr";
import { Constants } from '../core/constants';
import { UpdateInterviewActivityLog } from "Utils/participantInfo";
import { informationSection } from './styles/HomeScreen.styles';

export interface NotJoinedProps {
    message: string;
    joinCallHandler(): void;
    homeHandler(): void;
    screenWidth: number;
}

const YELLOW = '#ffb100';

const connection = new signalR.HubConnectionBuilder()
    .withUrl("/hub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
    })
    .build();


connection.start().catch((err) => document.write(err));

let modelone: ParticipantInfo = ParticipantModel();




connection.on("sendGroupMsg", (message: string, username: string, userid: number, type: string) => {
   

    if (username != modelone.userName || userid != modelone.userId) {

        if ("cActive") {

            let element = document.getElementById("btnJoinInterview") as HTMLButtonElement;
            element.style.display = "block";
            element.click();

            element = document.getElementById("btnNoShow") as HTMLButtonElement;
            element.style.display = "none";

            element = document.getElementById("btnEvaluate") as HTMLButtonElement;
            element.style.display = "none";

            const elementdv = document.getElementById("dvMessageTop") as HTMLDivElement;
            if (elementdv != null)
                elementdv.style.display = "none";

            let elementDiv = document.getElementById("dvMessage") as HTMLDivElement;
            elementDiv = document.getElementById("dvMessage") as HTMLDivElement;
            elementDiv.innerText = "Candidate has already joined the interview. Please click on \"Join Interview\" button.";


            connection.send("RemoveFromGroup", uriGid);
        }

    }
   
});






const CandidateStatusChanged = (status: number, btnId: string, bgColor: string): void => {

    UpdateCandidateStatus(uriCode, status);
    // UpdateStatus(status);
    //const Ids = ["btnSelect", "btnReject", "btnNoShow"];
    // const Ids = ["btnNoShow","btnJoinInterview"];

    // for (let i = 0; i < Ids.length; i++) {
    let element = document.getElementById("btnJoinInterview") as HTMLButtonElement;
    element.style.display = "none";
    element = document.getElementById("btnNoShow") as HTMLButtonElement;
    element.style.display = "none";

    element = document.getElementById("btnEvaluate") as HTMLButtonElement;
    if (element != null)
        element.style.display = "none";

    const elementdv = document.getElementById("dvMessageTop") as HTMLDivElement;
    if (elementdv != null)
        elementdv.style.display = "none";

    let elementDiv = document.getElementById("dvMessage") as HTMLDivElement;
    elementDiv = document.getElementById("dvMessage") as HTMLDivElement;
    elementDiv.innerText = "Thank you for your feedback.";
    //  }


};

const getEncCodeFromUrl = (): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q');
};

const CallEndandEvaluate = (): void => {
    const getParticipant: ParticipantInfo = ParticipantModel();
    let codeQ: string | null = "";

    codeQ = getEncCodeFromUrl();

    (async () => {
        await postinterviewcomplete(codeQ);
    })().then(function () {
        const message = "##UserRole# has marked the interview as Completed and proceeded to fill out the rating in the evaluation page.";
        UpdateInterviewActivityLog("Call", message); //#Static
        if (getParticipant.evalURL != undefined)
            window.location.href = getParticipant.evalURL;
    });
}

export default (props: NotJoinedProps): JSX.Element => {
    modelone = ParticipantModel();

    const goHomePage = 'No Show';
    const joinCall = 'Join Interview';
    connection.send("AddToGroup", uriGid);
    return (
        <>
        <div className={informationSection} id="dvMessageTop">Please wait for the candidate to join the interview. Once the candidate joins, you will be automatically connected.</div>
        <Stack verticalAlign="center" tokens={mainStackTokens} className={endCallContainerStyle} style={{ width: "53.625rem", textAlignLast:"center" }}>
            <Stack tokens={upperStackTokens}>
                <div className={endCallTitleStyle} id="dvMessage">{props.message}</div>
                <Stack horizontal tokens={buttonsStackTokens} style={{ justifyContent: "center" }}>
                    <PrimaryButton className={buttonStyle} id="btnJoinInterview" onClick={props.joinCallHandler}>
                        <VideoCameraEmphasisIcon className={videoCameraIconStyle} size="medium" />
                        {joinCall}
                    </PrimaryButton>
                    {modelone.role != "Spoc" && (<ActionButton id="btnNoShow" aria-class="normal" className={noShowButtonStyle} onClick={(event) => CandidateStatusChanged(11, "btnNoShow", YELLOW)} style={{ display: "block", margin: "0px" }}>
                        {/* <Icon iconName="Copy" className={copyIconStyle} />*/}
                        {/*{NoShowString}*/}
                        <span className={RatingButtonStyle}>No Show</span>
                    </ActionButton>)}
                    {modelone.role != "Spoc" && window._allowUser == "notjoined"  &&(
                        <ActionButton id="btnEvaluate" aria-class="normal" className={noShowButtonStyle} onClick={(event) => CallEndandEvaluate()} style={{ display: "block", backgroundColor: "red", borderColor: "red", width: props.screenWidth < Constants.MINI_HEADER_WINDOW_WIDTH ? "auto" : "" }}>
                            <span className={RatingButtonStyle}> End-Call & Evaluate </span>
                        </ActionButton>
                        )}
                    {/*        <DefaultButton className={buttonStyle} onClick={props.homeHandler}>*/}
                    {/*  {goHomePage}*/}
                    {/*</DefaultButton>*/}
                </Stack>
                <div className={bottomStackFooterStyle}>
                    {/*<a href="https://github.com/Azure-Samples/communication-services-web-calling-hero/issues">Give Feedback</a>*/}
                    {/*&nbsp;on this sample app on Github*/}
                </div>
            </Stack>
            </Stack>
        </>
    );
};
